import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Brain, Sparkles, ArrowLeft } from 'lucide-react';

const IAPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-950 via-blue-900 to-slate-900 text-white flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        <button
          onClick={() => navigate(-1)}
          className="mb-10 inline-flex items-center space-x-2 px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full hover:bg-white/20 transition-all"
        >
          <ArrowLeft className="w-5 h-5" />
          <span>Retour</span>
        </button>

        <div className="flex items-center justify-center space-x-3 mb-8">
          <Brain className="w-14 h-14 text-amber-400" />
          <Sparkles className="w-10 h-10 text-amber-500 animate-pulse" />
        </div>

        <h1 className="text-4xl md:text-5xl font-bold mb-4">
          <span className="bg-gradient-to-r from-amber-300 via-amber-400 to-amber-500 bg-clip-text text-transparent">
            Bientôt disponible
          </span>
        </h1>

        <p className="text-lg text-gray-300 mb-10 leading-relaxed">
          Nos solutions d&apos;intelligence artificielle arrivent très bientôt.
          Restez connectés !
        </p>

        <button
          onClick={() => navigate('/')}
          className="bg-gradient-to-r from-amber-500 to-amber-600 text-black px-8 py-3 rounded-xl font-bold hover:shadow-lg transition-all"
        >
          Retour à l&apos;accueil
        </button>
      </div>
    </div>
  );
};

export default IAPage;
